export default __webpack_public_path__ + "static/media/avatar-1.acbb147a.jpg";